
export const SET_VERIFY_OTP = 'SET_VERIFY_OTP';
export const SET_VERIFY_EMAIL = 'SET_VERIFY_EMAIL';

export const SET_VERIFY_OTP_ERROR = 'SET_VERIFY_OTP_ERROR';
export const SET_VERIFY_EMAIL_ERROR = 'SET_VERIFY_EMAIL_ERROR';